import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import AddOrUpdateTickets from "./AddOrUpdateTickets";
import SupportTicketsTabs from "./SupportTicketsTabs";
import CustomDrawer from "src/components/GeneralComponents/CustomDrawer";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import GrButton from "src/design-system/components/GrButton";
import GrTabs from "src/design-system/components/GrTabs";
import { gr } from "src/design-system/tokens";
import GrPage from "src/design-system/components/GrPage";

function SupportTicket() {
  const [Open, setOpen] = useState("");
  const [Solved, setSolved] = useState("");
  // Back from a ticket returns the tab it was opened from (the detail page sends it as router state).
  const { state } = useLocation();
  const [tabValue, setTabValue] = useState(
    typeof state === "number" ? state : 0
  );
  const [drawerState, setDrawerState] = useState(false);
  // Bumped after a new ticket: the Open list reloads from the server (right total, never the Closed list).
  const [listVersion, setListVersion] = useState(0);
  const [userList, setUserList] = useState([]);

  const handleOpenDrawer = () => {
    setDrawerState(true);
  };

  const handleCloseDrawer = () => {
    setDrawerState(false);
  };

  const handleTicketAdded = () => {
    setTabValue(0);
    setListVersion((version) => version + 1);
  };

  const handleChanges = (event, newValue) => {
    setTabValue(newValue);
  };

  const TABS_OPTIONS = [
    {
      title: "Open",
      count: Open ? Open : 0,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          setSolved={setSolved}
          valueData={"open"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: "Closed",
      count: Solved ? Solved : 0,
      component: (
        <SupportTicketsTabs
          setOpen={setOpen}
          setSolved={setSolved}
          tabValue={tabValue}
          valueData={"solved"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
  ];

  return (
    <GrPage sx={{ pb: gr.space[8] }}>
      <GrPageHeader
        title="Support Tickets"
        actions={<GrButton onClick={handleOpenDrawer}>New Ticket</GrButton>}
      />
      <GrTabs
        value={tabValue}
        onChange={handleChanges}
        ariaLabel="Support tickets"
        tabs={TABS_OPTIONS.map((item, index) => ({
          value: index,
          label: item.title,
          count: item.count,
          id: `support-tab-${index}`,
          "aria-controls": `support-tabpanel-${index}`,
        }))}
      />
      {/* Only the open tab is mounted, as before; the key remounts it on a tab change so it loads its own list. */}
      <Box
        key={`${tabValue}-${listVersion}`}
        role="tabpanel"
        id={`support-tabpanel-${tabValue}`}
        aria-labelledby={`support-tab-${tabValue}`}
        sx={{ mt: gr.space[5] }}
      >
        {TABS_OPTIONS[tabValue]?.component}
      </Box>
      <CustomDrawer
        isOpenDrawer={drawerState}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle="New Ticket"
        componentToPassDown={
          <AddOrUpdateTickets
            formType="ADD"
            onCloseDrawer={handleCloseDrawer}
            onAdded={handleTicketAdded}
          />
        }
      />
    </GrPage>
  );
}

export default SupportTicket;
